import { render, staticRenderFns } from "./SaleType.vue?vue&type=template&id=24e3a5ac&scoped=true&"
import script from "./SaleType.vue?vue&type=script&lang=js&"
export * from "./SaleType.vue?vue&type=script&lang=js&"
import style0 from "./SaleType.vue?vue&type=style&index=0&id=24e3a5ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3a5ac",
  null
  
)

export default component.exports